module.exports = __webpack_public_path__ + "img/new-logo.80324b6b.svg";